import type { PropsWithChildren } from 'react'

import { AuthGate } from 'components/auth-gate'

// Thin pass-through to <AuthGate>, the in-house auth boundary that replaced the winninAuth MFE.
// Mounted below the host ApolloProvider in index.tsx so AuthGate uses the host Apollo client directly.
export function AuthWrapper({ children }: PropsWithChildren) {
  return <AuthGate>{children}</AuthGate>
}
